// removed by extract-text-webpack-plugin
module.exports = {"list__data":"SimpleList-hashed__list__data__2Woa0","list__dataLabel":"SimpleList-hashed__list__dataLabel__1CvRf"};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/MobileViewGenerator/subdirectives/list/SimpleList/SimpleList-hashed.scss
// module id = 668
// module chunks = 0